<template>
    <div class="maskL"></div>
    <div class="maskR"></div>
</template>

<script>
    import { reactive, toRefs, computed } from 'vue'

    export default {
        name: 'Transition',
        props: {},
        setup: (props, context) => {
            const state = reactive({
                props,
            })

            return {
                ...toRefs(state),
            }
        }
    }
</script>

<style scoped lang="scss">
    .maskL, .maskR {
        position: absolute;
        height: 100%;
        width: 100%;
        background-image: url("~@/assets/yunwen/yunwen1.jpg");
        background-repeat: repeat;
        background-size: 30%;
        z-index: 999;
    }

    .maskL {
        left: -100%;
        background-position: right;

        animation-name: maskL-anima;
        animation-duration: 2s;
    }

    @keyframes maskL-anima {
        0% {
            left: 0%;
            opacity: 100%;
        }

        100% {
            left: -100%;
            opacity: 0%;
        }
    }

    .maskR {
        left: 100%;

        animation-name: maskR-anima;
        animation-duration: 2s;
    }

    @keyframes maskR-anima {
        0% {
            left: 0%;
            opacity: 100%;
        }

        100% {
            left: 100%;
            opacity: 0%;
        }
    }
</style>